<template>
  <div>
    <home-header></home-header>
    <div class="content page-width">
      <personal-center></personal-center>
      <div class="margin-top-30"></div>
      <plan-list></plan-list>
    </div>
    <Foot></Foot>
  </div>
</template>

<script>
import HomeHeader from '@/common/components/Header'
import Foot from '@/common/components/Foot'
import PlanList from './components/PlanList'
import PersonalCenter from '@/common/components/PersonalCenter'
import common from "@/common/js/common.js";
export default {
  name: 'TeachPlan',
  components: {
    HomeHeader,
    Foot,
    PlanList,
    PersonalCenter
  },
  data: function () {
    return {
      arrs: []
    }
  },
  created(){
    if(this.$route.name !== 'myPersonalStudyFee'&&localStorage.getItem('token')){
      this.axios.get('/sys/login/userinfo').then(res=>{
        let userInfo = res.result.userInfo
        userInfo.eduLogo = res.result.eduLogo || null
        userInfo.headTitle = res.result.headTitle
        userInfo.pageTitle = res.result.pageTitle
        document.title = `${userInfo.eduName} - ${userInfo.pageTitle}`
        this.common.setStorage('userInfo', userInfo)
        this.$store.commit('SET_USERINFO', userInfo)
        console.log('userInfo 教学计划')
      })
    }
  },
  methods: {
    handleGetDataSucc (res) {
      res = res.data
      if (res.ret && res.data) {
        const data = res.data
        this.arrs = data.plan
        console.log(this.arrs)
      }
    }
  },
}
</script>
<style lang="stylus" scoped>
  @import '~styles/varibles.styl'
  .page-width{
    width:$pageWidth;
    margin:0 auto;
    .content-right{
      margin-top:30px;
      .localtion{
        line-height 30px;
        border-bottom:1px solid $borderColor;
        margin-bottom:20px;
      }
    }
  }
  .content-left{
    background:#f7f6f6;
  }
</style>



// WEBPACK FOOTER //
// src/pages/teachplan/Index.vue